import Typography from '@material-ui/core/Typography';
import React, { useEffect } from 'react';

import { useTranslation } from '../../../hooks/useTranslation';
import { RegistrationFormProps } from '../registration.types';
import { Box, Divider, Grid } from '@material-ui/core';
import Dropdown from '../../dropdown';
import TextField from '../../text-field';
import SSNTextField from '../../ssn-text-field';
import { PersonPrimaryIdType } from '../../../__generated__/pge-types';
import { statesAndProvincesGrouping } from '../../utility/state-dropdown';
import EinTextField from '../../ein-text-field';

interface NewBusinessIdentityProps extends RegistrationFormProps {
  classes: any;
}

const NewBusinessIdentity = (props: NewBusinessIdentityProps) => {
  const { t } = useTranslation();
  const { classes } = props;
  const { form } = props;

  useEffect(() => {
    //Select EIN as a default ID type for business if the value is not selected by the user
    if (!form.values.IDValue) {
      void form.setValue('IDType', PersonPrimaryIdType.Ein);
    }
  }, []);

  return (
    <div style={{ padding: 0 }}>
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'flex-start',
        }}
      >
        <Grid item xs={12}>
          <Typography variant={'h2'} style={{ padding: '0 0 8px 0' }}>
            {t('SIGNUP_PROVIDE_YOUR_BUSINESS_INFO')}
          </Typography>
          <Typography style={{ marginBottom: 4, marginTop: 4 }}>
            {t('SIGNUP_PROVIDE_YOUR_BUSINESS_INFO_DESC')}
          </Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            name={'businessName'}
            required
            data-testid="businessName"
            label={t('BUSINESS_NAME_FOR_REGISTRATION')}
            inputProps={{
              minLength: 1,
              maxLength: 60,
            }}
            style={{ width: '100%' }}
            {...form.props('businessName')}
            error={Boolean(form.errors.businessName)}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <Divider css={{ margin: '16px 0' }} />
        </Grid>

        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '16px',
            }}
          >
            <Box style={{ margin: '8px 0' }}>
              <Dropdown
                label={''}
                data-testid="id-type"
                value={form.values.IDType}
                selectionList={[
                  {
                    value: PersonPrimaryIdType.Ein,
                    label: t('EIN'),
                  },
                  {
                    value: PersonPrimaryIdType.Ssn,
                    label: t('SOCIAL_SECURITY_NUMBER'),
                  },
                  {
                    value: PersonPrimaryIdType.Dl,
                    label: t('DRIVERS_LICENSE'),
                  },
                ]}
                onChange={e => {
                  void form.setValue('IDType', e.target.value);
                  void form.setValue('IDValue', '');
                }}
              />
            </Box>
            {form.values.IDType === PersonPrimaryIdType.Ssn && (
              <SSNTextField
                name="IDValue"
                data-testid="ssn-field"
                label={t('SOCIAL_SECURITY_NUMBER')}
                style={{
                  width: '100%',
                  background: 'transparent',
                }}
                className={classes.root}
                {...form.props('IDValue')}
                error={Boolean(form.errors.IDValue)}
              />
            )}

            {form.values.IDType === PersonPrimaryIdType.Dl && (
              <>
                <Box style={{ margin: '8px 0' }}>
                  <Dropdown
                    data-testid="state-field"
                    label={''}
                    value={form.values.IDState}
                    selectionList={[
                      { label: 'OR', value: 'OR' },
                      ...statesAndProvincesGrouping.unitedStates
                        .filter((v: string) => v !== 'OR')
                        .map((v: string) => ({ label: v, value: v })),
                    ]}
                    onChange={e => {
                      void form.setValue('IDState', e.target.value);
                    }}
                  />
                </Box>
                <TextField
                  data-testid="dl-field"
                  inputProps={{
                    maxLength: 19,
                    style: { background: '#FFF' },
                  }}
                  style={{
                    width: '100%',
                    background: 'transparent',
                  }}
                  name="IDValue"
                  {...form.props('IDValue')}
                  error={Boolean(form.errors.IDValue)}
                  label={t('DRIVERS_LICENSE')}
                  delayedTextMask={true}
                />
              </>
            )}

            {form.values.IDType === PersonPrimaryIdType.Ein && (
              <EinTextField
                data-testid="validate-ein-number"
                name="ein"
                {...form.props('IDValue')}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default NewBusinessIdentity;
